import React from "react";
import { useEffect, useState } from "react";
import { useRouter } from "next/router";
import Image from "next/image";
import { useWidth } from "@/utils/resize";
import Head from "next/head";
import dayjs from "dayjs";
import { NextPage, GetStaticProps, GetServerSideProps } from "next";
import { getBlogDetail } from "@/service/index";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useTranslation } from "next-i18next";
import styles from "./report.module.scss";
import { Button } from "antd";
import codePng from "@/public/images/code.png";
import { getCookie, setCookie } from "cookies-next";
import { downloadFile } from "@/utils/download";
import buriedsdk from "@/utils/zz-buried/index";
import Layout from "@/components/layout";
import fb from "@images/report/icon_facebook.png";
import linkin from "@images/report/icon_Linkedin.png";
import tw from "@images/report/icon_Twitter.png";
import fb2 from "@images/report/facebook.png";
import linkin2 from "@images/report/instagram.png";
import tw2 from "@images/report/twitter.png";
import { getLangLink } from "@/utils/lang";
type postType = {
  post: any;
  previousPost: any;
  nextPost: any;
  relatedPosts: any[];
};
const Report: NextPage<{
  Data: any;
}> = function (props) {
  const { t } = useTranslation(["blog"]);
  const router = useRouter();
  const { locales, locale: activeLocale } = router;
  const [isAuthorized, setAuthorized] = useState(false);
  let [loading, setLoading] = useState(false);
  let [completeData, setCompleteData] = useState("");
  let [width, setWidth] = useState(0);
  let loginMobileUrl: any = process.env.loginMobileUrl;
  let publicUrl: any = process.env.portalUrl;
  let jumpUrl;
  const Data: any = props.Data;
  // const list: any = props.list;
  const { post, previousPost, nextPost, relatedPosts }: postType = Data;
  console.log(post, "post ====> ");
  useEffect(() => {
    setWidth(window.innerWidth);
    let [unLoginData, hideData = ""] = post?.content?.split("###");
    // TODO: 注释登录
    const isAuth = getCookie("authorized-token") ? true : false;
    console.log(isAuth, "isAuth ==> ");
    if (isAuth) {
      setCompleteData(`${unLoginData}${hideData}`);
      setAuthorized(isAuth);
      autoDownload();
    } else {
      setCompleteData(`${unLoginData}`);
    }
  }, []);
  // 登录跳转回来自动下载
  const autoDownload = () => {
    const { download = false } = router.query;
    download === "true" && handleDownload();
  };
  // 清除自动下载标识
  const clearQuery = () => {
    const { origin, pathname } = location;
    history.replaceState(null, "", `${origin}${pathname}`);
  };
  const formatDate = (time, formatType = "YYYY-MM-DD") => {
    if (!time) return "";
    return dayjs(time).format(formatType);
  };
  const handlejump = (download = false) => {
    if (!download) {
      buriedsdk.buried({
        event: `报告详情_${width > 1024 ? "Web" : "H5"}`,
        scene: `底部引导_注册登录`,
        URL: process.env.publicApiDomain,
      });
    }
    jumpUrl =
      width > 1024
        ? `${publicUrl}/login?fromPath=${window.location.href}`
        : loginMobileUrl + `?fromWebsite=${window.location.href}`;
    window.open(`${jumpUrl}?download=${download}&website=true`, "_self");
  };
  const handleDownload = async () => {
    buriedsdk.buried({
      event: `${width > 1024 ? "Web" : "H5"}报告下载`,
      scene: `用户点击”下载报告“按钮触发`,
      URL: process.env.publicApiDomain,
    });
    clearQuery();
    if (getCookie("authorized-token")) {
      const filename =
        post.url?.match(/\/blog\/([\w\W]+\.pdf)$/i) &&
        post.url?.match(/\/blog\/([\w\W]+\.pdf)$/i)[1];
      setLoading(true);
      const res = await fetch(post.url);
      const blob = await res.blob();
      setLoading(false);
      downloadFile(blob, filename);
      return;
    } else {
      handlejump(true);
    }
  };
  return (
    <div>
      <Layout header={true} footer={true}>
        <Head>
          <title>
            {post?.seoTitle || "TikTok Online Analytics Tool | TikMeta Insight"}
          </title>
          <meta
            name="keywords"
            content={
              post?.seoTitle ||
              "tiktok online analytics tool, tiktok user analytics, tiktok account analytics,tiktok influencer analytics,tiktok video downloader,download without watermark, how to see tiktok analytics"
            }
          />
          <meta
            name="description"
            content={post?.seoDesc || "tiktok online analytics tool"}
          />
        </Head>
        <div className={`${styles["report-detail"]}`}>
          <main className={`defeaultContainer ${styles.container}`}>
            <div className={styles.share_wrap}>
              <a
                target={"_blank"}
                href={`http://www.linkedin.com/shareArticle?mini=true&ro=true&title=${
                  post?.title
                }&url=${
                  process.env.NEXT_PUBLIC_PORTAL_URL + "/blogs/" + post?.seoUrl
                }&armin=armin`}
                className="mr-[16px]"
                rel="noreferrer"
              >
                <Image width={24} height={24} src={linkin2} alt=""></Image>
              </a>
              <a
                target={"_blank"}
                href={`https://www.facebook.com/sharer/sharer.php?u=${
                  process.env.NEXT_PUBLIC_PORTAL_URL + "/blogs/" + post?.seoUrl
                }`}
                className="mr-[16px]"
                rel="noreferrer"
              >
                <Image width={24} height={24} src={fb2} alt=""></Image>
              </a>
              <a
                target={"_blank"}
                href={`https://twitter.com/intent/tweet?text=${
                  post?.title
                }&url=${
                  process.env.NEXT_PUBLIC_PORTAL_URL + "/blogs/" + post?.seoUrl
                }`}
                rel="noreferrer"
              >
                <Image width={24} height={24} src={tw2} alt=""></Image>
              </a>
            </div>
            <div className={styles.pageTop + " text-[14px] leading-[21px]"}>
              <a
                href={process.env.portalUrl + getLangLink("", activeLocale)}
                className="!text-[#708096] hover:!text-[#ff3e5f]"
              >
                {t("Home")}
              </a>
              <span className="text-[#708096]"> / </span>
              <a
                href={
                  process.env.portalUrl +
                  getLangLink("/tiktok-reports", activeLocale)
                }
                className="!text-[#708096] hover:!text-[#ff3e5f]"
              >
                {t("Reports")}
              </a>
              <span className="text-[#708096]"> / </span>
              <span className="text-[#2E384E]">{t("Report detail")}</span>
            </div>
            <div className={`${styles.wrapper} flex`}>
              <div className={`${styles.detailLeft}`}>
                <section className={`${styles.header} mb-[16px]`}>
                  <div className={`${styles["header-left"]}`}>
                    <img
                      className={`${styles.topImg}`}
                      src={post?.cover}
                      alt="Report cover"
                    />
                  </div>
                  <div className={`${styles["header-right"]}`}>
                    <div className="header-right__top">
                      <h3
                        className={`${styles["header-title"]} text-[24px] leadding-[35px] text-[#2E384E] font-bold mb-[14px]`}
                      >
                        {post?.title}
                      </h3>
                      <p
                        className={`${styles["header-desc"]} text-[14px] leading-[20px] text-[#708096] mb-[20px]`}
                      >
                        {post?.desc}
                      </p>
                    </div>
                    <div className={`${styles["header-right__bottom"]}`}>
                      <span
                        className={`${styles.time} text-[#B8C0CB] text-[14px] leadding-[20px] mb-[27px] flex items-center justify-between`}
                      >
                        <div className="flex items-center">
                          {post?.authorPic ? (
                            <Image
                              src={post?.authorPic}
                              width={32}
                              height={32}
                              alt=""
                            ></Image>
                          ) : null}
                          {post?.author && (
                            <span className="ml-[16px] mr-[26px] text-[16px] text-[#0A122C]">
                              {post?.author}
                            </span>
                          )}
                          {post?.createTime ? formatDate(post?.createTime) : ""}
                        </div>
                        <div className={styles.share_mobile}>
                          <a
                            target={"_blank"}
                            href={`http://www.linkedin.com/shareArticle?mini=true&ro=true&title=${
                              post?.title
                            }&url=${
                              process.env.NEXT_PUBLIC_PORTAL_URL +
                              "/tiktok-reports/" +
                              post?.seoUrl
                            }&armin=armin`}
                            className="mr-[16px]"
                            rel="noreferrer"
                          >
                            <Image
                              width={24}
                              height={24}
                              src={linkin}
                              alt=""
                            ></Image>
                          </a>
                          <a
                            target={"_blank"}
                            href={`https://www.facebook.com/sharer/sharer.php?u=${
                              process.env.NEXT_PUBLIC_PORTAL_URL +
                              "/tiktok-reports/" +
                              post?.seoUrl
                            }`}
                            className="mr-[16px]"
                            rel="noreferrer"
                          >
                            <Image
                              width={24}
                              height={24}
                              src={fb}
                              alt=""
                            ></Image>
                          </a>
                          <a
                            target={"_blank"}
                            href={`https://twitter.com/intent/tweet?text=${
                              post?.title
                            }&url=${
                              process.env.NEXT_PUBLIC_PORTAL_URL +
                              "/tiktok-reports/" +
                              post?.seoUrl
                            }`}
                            rel="noreferrer"
                          >
                            <Image
                              width={24}
                              height={24}
                              src={tw}
                              alt=""
                            ></Image>
                          </a>
                        </div>
                      </span>
                      <Button
                        type="primary"
                        loading={loading}
                        onClick={() => handleDownload()}
                        className={`${styles.download} !rounded-[8px] h-[36px] w-[136px] leadding-[36px] flex items-center`}
                      >
                        <i className="iconfont icon-xiazai text-[12px]"></i>
                        <span className="ml-[8px]">{t("Download")}</span>
                      </Button>
                    </div>
                  </div>
                </section>
                <article className={`${styles.article} relative`}>
                  <div
                    dangerouslySetInnerHTML={{
                      __html: completeData,
                    }}
                  ></div>
                  {isAuthorized ? (
                    post?.author ? (
                      <div className="flex p-[30px] bg-[#F7F8FA] rounded-[8px] mt-[65px] lg1024:p-[20px]">
                        {width > 1024 && post?.authorPic && (
                          <div>
                            <Image
                              src={post?.authorPic}
                              width={80}
                              height={80}
                              alt=""
                            ></Image>
                          </div>
                        )}
                        <div className="flex-1 ml-[20px] lg1024:ml-0">
                          <div className="lg1024:flex items-center">
                            {width < 1024 && post?.authorPic && (
                              <div>
                                <Image
                                  src={post?.authorPic}
                                  width={40}
                                  height={40}
                                  alt=""
                                ></Image>
                              </div>
                            )}
                            <h4 className="text-[16px] text-[#0A122C] mb-[14px] lg1024:mb-0 lg1024:ml-[20px]">
                              {post?.author}
                            </h4>
                          </div>
                          <div className="my-0 text-[16px] leading-[18px] !text-[#191919] lg1024:mt-[16px] lg1024:text-[12px] lg1024:leading-[14px]">
                            {post?.authorDesc}
                          </div>
                        </div>
                      </div>
                    ) : null
                  ) : (
                    <div className={`${styles.loginMask} absolute`}>
                      <p className={`${styles.loginTip} mb-[16px]`}>
                        {t("auth")}
                      </p>
                      <Button
                        type="primary"
                        onClick={() => handlejump()}
                        className={`${styles.loginBtn}  !rounded-[30px] leadding-[30px] `}
                      >
                        {t("Register / Login")}
                      </Button>
                    </div>
                  )}
                </article>
              </div>
            </div>
          </main>
        </div>
      </Layout>
    </div>
  );
};

export const getServerSideProps: GetServerSideProps = async (context) => {
  // fetch 获取blog 为id 的文章数据;
  const { locale, params } = context;
  const res = await getBlogDetail({
    seoUrl: params?.id,
    language: "en",
    context,
  });
  const Data = (res && res.data) || [];
  console.log(res, "Data =======> ==> ");
  return {
    props: {
      ...(await serverSideTranslations(locale!, [
        "common",
        "nav",
        "blog",
        "about",
        "footer",
      ])),
      // Will be passed to the page component as props
      // Data: res.data,
      Data,
    },
  };
};
export default Report;
